import React, { useEffect, useState } from 'react'
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom'
import 'antd/dist/reset.css'
import 'App.scss'
import Dashboard from 'pages/Dashboard'
import Profiles from 'pages/Profiles'
import AccountLiveMetriX from 'pages/Dashboard/AccountMetriXFree'
//import AccountMetriX from 'pages/Dashboard/AccountMetriX'
import AccountMetriXImport from 'pages/Dashboard/AccountMetrixImport'
import AccountsOverview from 'pages/Dashboard/AccountsOverview'
import FreeTrial from 'pages/Dashboard/AccountsOverview/FreeTrial'
import MaTrixRiskReward from 'pages/Dashboard/AccountsOverview/MaTrixRiskReward'
import Numerologist from 'pages/Dashboard/Numerologist';
import NumberlogistProduct from 'pages/Dashboard/Numerologist/Products';
import ProductDetail from 'pages/Dashboard/Numerologist/Products/ProductDetail';
import Login from 'pages/Login'
import SignUp from 'pages/SignUp'
import ForgetPassword from 'pages/SignUp/ForgetPassword'
import NewPassword from 'pages/SignUp/NewPassword';
import AccountManager from 'pages/Dashboard/Manager'
import AccountInfoPage from 'pages/Profiles/accountInfoPage'
import AccountSecurityoPage from 'pages/Profiles/accountSecurity'
import EquitySimulator from 'pages/Dashboard/EquitySimulator'
import { AccountProvider } from 'components/Provider/account';
import Numerology from 'pages/Numerology';
import DetailStar from 'pages/Numerology/DetailStar';
import ProfileSetup from 'pages/SignUp/Step/ProfileSetup';
import BehavioralPerformance from 'pages/Dashboard/BehavioralPerformance';
import TelegramCallback from 'pages/TelegramCallback';
import CallbackLogin from 'pages/Login/CallbackLogin';
import { mixGetV1, mixPostV1 } from 'services/mixin';
import { API_URL, API_URL_3 } from 'env';
import NotificationMainPage from 'pages/Notifications';
import NotificationDetailPage from 'pages/Notifications/detail';
import Affiliate from 'pages/Affiliate';
import TeamsDashboard from 'pages/Profiles/Team/index';
import TeamDetails from 'pages/Profiles/Team/teamDetail';
import ResetPasswordMail from 'pages/Email/ResetPasswordMail';
import OTPPage from 'pages/SignUp/Otp';
import Academy from 'pages/Academy';
import QuizPage from 'pages/Academy/Quiz';
import PickAccount from 'pages/Academy/PickAccount';
import MainStorePage from 'pages/Store';
import StoreProductDetail from 'pages/Store/detail';
import StoreUserInventory from 'pages/Store/inventory';
import InventoryDetail from 'pages/Store/component/inventoryDetail';
import ToolFrame from 'pages/Store/ToolFrame';
import PdfCustomPage from 'pages/pdf';
import FreePDF from 'pages/pdf/pdfFree';
import TeamMemberTBI from 'pages/Profiles/Team/TeamMember/TBI'
import DownloadPage from 'pages/Bots/Download';
import HelpCenter from 'pages/Help';
import HelpDetail from 'pages/Help/detail';
import LibraryPage from 'pages/Library';
import LibraryPdfViewer from 'pages/Library/pdf_viewer';
import LiveMetrix from 'pages/Dashboard/Metrix/Live'
import MetrixPDF from 'pages/Dashboard/Metrix/pdf'
import DashBoardMetrix from 'pages/Dashboard/Metrix/Dashboard'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { config } from './wagmi_config/config'
import Leaderboard from 'pages/Academy/Leaderboard'
import CommunityLeaderboard from 'pages/Community/LeaderBoard'
import CommunityExpert from 'pages/Community/Expert'
import CommunityManagerNetwork from 'pages/Community/Manager_Network'
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { firebaseConfig, vapidKey } from 'services/firebase_config'
import { getMessaging, onMessage, getToken, isSupported, Messaging } from "firebase/messaging";
import { uploadFmcToken } from 'services/fmc_token_upload';
import MetrixDashboardV2 from 'pages/Dashboard/Metrix_v2/Live'
import { NotificationProvider } from 'hooks/useNotification'


// Initialize Firebase
declare global {
  interface Window {
    DOMAIN_API: string;
    SITE_ID: string;
  }
}

const queryClient = new QueryClient()
const App: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const [checkLogin, setCheckLogin] = useState(false)
  const params = new URLSearchParams(new URL(window.location.href).search);
  const code1 = params.get("code");

  // const app = initializeApp(firebaseConfig);
  // const [messaging, setMessaging] = useState<Messaging | null>(null);

  // useEffect(() => {
  //   isSupported().then((supported) => {
  //     if (supported) {
  //       const msg = getMessaging(app);
  //       setMessaging(msg);
  //       console.log("FCM được hỗ trợ trên trình duyệt này.");
  //     } else {
  //       console.log("Trình duyệt không hỗ trợ FCM (Ví dụ: Safari iOS chưa Add to Home Screen).");
  //     }
  //   }).catch(err => console.error("Lỗi kiểm tra support:", err));
  // }, [app]);

  // 1. Correct way to register the Service Worker and get the FCM Device Token
  // async function requestNotificationPermission() {
  //   if (!messaging) return;
  //   try {
  //     // Request permission from the user
  //     const permission = await Notification.requestPermission();

  //     if (permission === "granted") {
  //       // Register the service worker manually to ensure it points to your public folder
  //       const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
  //       await navigator.serviceWorker.ready; // Wait until it's fully active

  //       // Get the ACTUAL FCM token required for sending messages
  //       const fcmToken = await getToken(messaging, {
  //         vapidKey: vapidKey,
  //         serviceWorkerRegistration: registration 
  //       });

  //       // COPY THIS TOKEN FROM YOUR CONSOLE LOG!
  //       console.log('Your FCM Device Token:', fcmToken);
  //       if (fcmToken && token) {
  //         uploadFmcToken(fcmToken);
  //       }

  //     } else {
  //       console.log('Notification permission denied.');
  //     }
  //   } catch (err) {
  //     console.error('An error occurred while registering:', err);
  //   }
  // }

  // useEffect(() => {
  //   if (token && messaging) {
  //     requestNotificationPermission();
  //   }
  // }, [token, messaging]);

  // // 2. Correct way to listen for foreground messages (when app is open)
  // useEffect(() => {
  //   if (messaging) {
  //     const unsubscribe = onMessage(messaging, (payload) => {
  //       console.log('Message received in foreground: ', payload);
  //       alert(`Notification: ${payload.notification?.title}\n${payload.notification?.body}`);
  //     });
  //     return () => unsubscribe();
  //   }
  // }, [messaging]);

  function getRedirectUrl(url: string): string | null {
    // Matches 'redirect_url=' followed by everything up to the next '&' or the end of the string
    const match = url.match(/[?&]redirect_url=([^&#]*)/);

    if (!match) {
      return null;
    }

    // decodeURIComponent handles any URL encoding (e.g., %2F instead of /)
    return decodeURIComponent(match[1]);
  }

  function getQRInviteData(url: string): string | null {
    // Matches 'join-via-qr' followed by an optional query string (starting with ?)
    const match = url.match(/join-via-qr(.*)/);
    if (!match) {
      return null;
    }
    // Return the query string if present, otherwise return 'true' to indicate the path was matched
    return match[1] ? decodeURIComponent(match[1]) : "true";
  }

  useEffect(() => {
    const url = window.location.href;
    var redirect_url = getRedirectUrl(url)
    const inviteQR = getQRInviteData(url)
    if (inviteQR) {
      localStorage.setItem('join_via_qr', inviteQR);
      localStorage.setItem('redirect_url', '/teams');
    }
    if (redirect_url && redirect_url.length > 0) {
      if (!token) {
        localStorage.setItem('redirect_url', redirect_url);
      }
      window.location.href = redirect_url
    }
  }, [])

  const handleCallback = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    // Verify state
    // const savedState = sessionStorage.getItem('google_oauth_state');

    if (code) {
      try {
        const response = await fetch(`${API_URL}/api/v1/google/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code, state })
        });

        const data = await response.json();
        if (data.status) {
          localStorage.setItem('token', data.data.access_token);
          // localStorage.setItem('user', JSON.stringify(data.data.info))
          // window.location.href = '/';
          const res2 = await mixGetV1(`/api/v1/be/user/${data.data.info.id}`)

          if (res2.status) {
            localStorage.setItem('user', JSON.stringify(res2.data))

            // message.success('Login successful!');
            window.location.reload()
          }
        }
      } catch (error) {
        console.error('Login error:', error);
      }
    }
  };

  useEffect(() => {
    const notLogin = ['/login', '/sign-up', '/forget-password', '/reset-password', '/verify-otp']
    if (notLogin.includes(location.pathname) === false && !token && code1) {
      handleCallback()
      return
    }
    if (notLogin.includes(location.pathname) === false && !token && !code1) {
      navigate('/sign-up')
    }
    if (notLogin.includes(location.pathname) === true && token) {
      navigate('/')
    }
    if (location.pathname === '/teams/join-via-qr' && token) {
      navigate('/teams')
    }

    setCheckLogin(true)

  }, [navigate, location.pathname, token, code1])


  return (
    <>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <NotificationProvider>
            <AccountProvider>

              {checkLogin &&
                <Routes>
                  <Route path='/' element={<Navigate to="/accounts-overview" replace />} />
                  <Route path='/login' element={<Login />} />
                  {/* <Route path=':tradePlatform/test/:id' element={<MetrixDashboardV2 />} /> */}
                  <Route path='/sign-up' element={<SignUp />} />
                  <Route path='/sign-up/step' element={<ProfileSetup />} />
                  <Route path='/forget-password' element={<ForgetPassword />} />
                  <Route path='/reset-password' element={<NewPassword />} />
                  <Route path='/verify-otp' element={<OTPPage />} />
                  <Route path='/academy' element={<Academy />} />
                  <Route path='/academy/quiz' element={<QuizPage />} />
                  <Route path='/academy/quiz/dashboard' element={<QuizPage />} />
                  <Route path='/academy/quiz/foundation' element={<QuizPage />} />
                  <Route path='/academy/quiz/day/:day' element={<QuizPage />} />
                  <Route path='/academy/quiz/:day' element={<QuizPage />} />
                  <Route path='/academy/leaderboard' element={<Leaderboard />} />
                  <Route path='/community/leaderboard' element={<CommunityLeaderboard />} />
                  <Route path='/community/expert' element={<CommunityExpert />} />
                  <Route path='/community/manager-network' element={<CommunityManagerNetwork />} />
                  <Route path='/community' element={<CommunityLeaderboard />} />
                  <Route path='/academy/my-account' element={<PickAccount />} />
                  <Route path='/profile' element={<Profiles />} />
                  <Route path=':tradePlatform/account-live-metrix/:id' element={<MetrixDashboardV2 />} />
                  <Route path=':tradePlatform/account-metrix/:id' element={<DashBoardMetrix />} />
                  <Route path='/accounts-overview' element={<AccountsOverview />} />
                  <Route path='/accounts-overview/matrix-risk-reward' element={<MaTrixRiskReward />} />
                  <Route path='/free-trial' element={<FreeTrial />} />
                  <Route path='/manager' element={<AccountManager />} />
                  <Route path='/profile/account' element={<AccountInfoPage />} />
                  <Route path='/profile/security' element={<AccountSecurityoPage />} />
                  <Route path='/teams' element={<TeamsDashboard />} />
                  <Route path='/teams/:id' element={<TeamDetails />} />
                  <Route path='/teams/:team/member/:id' element={<TeamMemberTBI />} />
                  <Route path='/profile/inventory' element={<StoreUserInventory />} />
                  <Route path='/profile/inventory/:id' element={<InventoryDetail />} />
                  <Route path='/equity-simulator' element={<EquitySimulator />} />
                  <Route path="/TBI" element={<Numerology />} />
                  <Route path="/TBI/:slug/:id" element={<DetailStar />} />
                  <Route path="/numerologist" element={<Numerologist />} />
                  <Route path="/numerologist-products" element={<NumberlogistProduct />} />
                  <Route path="/numerologist-products/:id" element={<ProductDetail />} />
                  <Route path=":tradePlatform/behavioral-performance/:id" element={<BehavioralPerformance />} />
                  <Route path="/api/v1/telegram/callback" element={<TelegramCallback />} />
                  <Route path='/callback-login' element={<CallbackLogin />} />
                  <Route path='/notifications' element={<NotificationMainPage />} />
                  <Route path='/notifications/:id' element={<NotificationDetailPage />} />
                  <Route path='/profile/affiliate' element={<Affiliate />} />
                  <Route path='/stores' element={<MainStorePage />} />
                  <Route path='/stores/:id' element={<StoreProductDetail />} />
                  <Route path="/stores/view/:id" element={<ToolFrame />} />
                  <Route path='/TBI_pdf' element={<FreePDF />} />
                  <Route path='/platform/download' element={<DownloadPage />} />
                  <Route path='/help' element={<HelpCenter />} />
                  <Route path='/help/:slug' element={<HelpDetail />} />
                  <Route path='/library' element={<LibraryPage />} />
                  <Route path='/library/view/:id' element={<LibraryPdfViewer />} />
                  <Route path='/library/:folderId' element={<LibraryPage />} />
                  {/* <Route path='test/:tradePlatform/account-live-metrix/:id' element={<LiveMetrix />} />
            <Route path='test/:tradePlatform/account-metrix/:id' element={<DashBoardMetrix />} /> */}
                  <Route path=':platform/:account_number/pdf-custom' element={<MetrixPDF />} />
                </Routes >
              }

            </AccountProvider>
          </NotificationProvider>
        </QueryClientProvider>
      </WagmiProvider >
    </>
  )
}


export default App
